<template>
<span>

    <v-toolbar flat color="white">
        <v-toolbar-title class="lime--text lighten-1">Gerenciar Banners</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <template>
            <v-btn color="blue-grey darken-2" dark class="mb-1" @click="loadBanners">
                <v-icon dark class="mdi mdi-sync"></v-icon>Atualizar
            </v-btn>
            <v-btn color="success" dark class="mb-1 ml-2" :to="{name: 'banner.add'}">
                <v-icon class="mdi mdi-plus"></v-icon>Adicionar Novo Banner
            </v-btn>
        </template>
    </v-toolbar>

    <v-card>
        <v-card-title>
            <v-text-field v-model="search" append-icon="search" label="Localizar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="banner" :search="search" :rowsPerPageItems="rowsPerPageItems">

          <template v-slot:[`item.bnnr_sec_nome`]="{ item }">
                <td>
                    {{ item.setor.bnnr_sec_nome}}
                </td>
            </template>

            <template v-slot:[`item.bnnr_figurar`]="{ item }">
                <td>
                    <v-switch color="lime" v-model="item.bnnr_figurar" @change="onChangeEventHandler(item.bnnr_id, $event)" class="my-switch"></v-switch>
                </td>
            </template>

            <template v-slot:[`item.acoes`]="{ item }">
                <v-tooltip top color="blue white--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="blue lighten-1" @click.prevent="editBanner(item)" v-on="on">
                            <v-icon dark>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>Editar</span>
                </v-tooltip>

                <v-tooltip top color="red white--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="red lighten-1" @click.prevent="deleteBanner(item)" v-on="on">
                            <v-icon dark class="mdi mdi-delete"></v-icon>
                        </v-btn>
                    </template>
                    <span>Excluir</span>
                </v-tooltip>

                <v-tooltip top color="teal darken-1 black--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="teal darken-1" @click.prevent="addImagemBanner(item)" v-on="on">
                            <v-icon dark class="mdi mdi-image-plus"></v-icon>
                        </v-btn>
                    </template>
                    <span>Adicionar Imagens</span>
                </v-tooltip>

                <v-tooltip top color="orange darken-1 black--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="orange darken-1 lighten-1" @click.prevent="listImagensBanner(item)" v-on="on">
                            <v-icon dark class="mdi mdi-image"></v-icon>
                        </v-btn>
                    </template>
                    <span>Ver Imagens</span>
                </v-tooltip>
            </template>

            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    Voce procurou por "{{ search }}" nenhum item localizado.
                </v-alert>
            </template>

        </v-data-table>
    </v-card>

</span>
</template>

<script>
import {
    URL_BASE
} from '../../../config/configs'

export default {
    created() {
        this.loadBanners()
    },
    computed: {

    },
    name: "BannerComponent",
    data() {
        return {
            search: '',
            rowsPerPageItems: [10, 20, 30, {
                "text": "$vuetify.dataIterator.rowsPerPageAll",
                "10": -1
            }],
            headers: [{
                    text: 'Nome',
                    value: 'bnnr_nome'
                },
                {
                    text: 'Setor',
                    value: 'bnnr_sec_nome'
                },
                {
                    text: 'Largura',
                    value: 'bnnr_w'
                },
                {
                    text: 'Altura',
                    value: 'bnnr_h'
                },
                {
                    text: 'Figurar',
                    value: 'bnnr_figurar'
                },
                {
                    text: 'Ações',
                    align: 'center',
                    sortable: false,
                    value: 'acoes'
                }
            ],
            banner: [],
            base_url: URL_BASE
        }
    },
    methods: {
        loadBanners() {
            this.$store.dispatch('loadBanners')
                .then(response => {
                    this.banner = response
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: 'Erro',
                        text: 'Dados não localizado',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
        },
        editBanner(item) {
            this.$router.push({
                name: 'banner.edit',
                params: {
                    bnnr_id: item.bnnr_id
                }
            });
        },
        addImagemBanner(item) {
            this.$router.push({
                name: 'banner.photo',
                params: {
                    bnnr_id: item.bnnr_id
                }
            });
        },
        listImagensBanner(item) {
            this.$router.push({
                name: 'bannerphotos',
                params: {
                    bnnr_id: item.bnnr_id
                }
            });
        },
        deleteBanner(item, index) {
            this.$swal({
                title: 'Você tem certeza?',
                text: "Você não poderá reverter isso",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#D32F2F',
                cancelButtonColor: '#1976D2',
                confirmButtonText: 'Sim, Exclua!'
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch('destroyBanner', item.bnnr_id)
                        .then(response => {
                            if (response) {
                                this.$swal({
                                    position: "center",
                                    icon: "success",
                                    title: 'Sucesso',
                                    text: 'Dados excluídos com sucesso',
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                                this.banner.splice(index, 1);
                            } else {
                                this.$swal({
                                    position: "center",
                                    icon: "error",
                                    title: 'Opssss!',
                                    text: 'Erro ao excluir dados',
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                            }
                        })
                        .catch(error => {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: 'Opssss!',
                                text: 'Algo errado aconteceu!',
                                showConfirmButton: true,
                                timer: 6000
                            });
                        })
                }
            })

        },
        onChangeEventHandler(bnnr_id, value) {
            this.$store.dispatch('updateBannerFigurar', {
                    bnnr_id: bnnr_id,
                    bnnr_figurar: value
                })
                .then(() => {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: 'Sucesso',
                        text: 'Status atualizado com sucesso',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: 'Opssss!',
                        text: 'Erro ao atualizar status',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
        },
    },
};
</script>

<style scoped>
.avatar {
    height: 40px;
    margin-top: 0.4rem;
}
</style>
